/**
 * Reason codes returned when a field is disabled.
 * @enum {string}
 */
export const DISABLE_REASONS = {
    PR_LOCKED: 'PR_LOCKED',
    NO_ACCESS: 'NO_ACCESS',
    SUBMITTED_TAB: 'SUBMITTED_TAB',
    PENDING_SB: 'PENDING_SB',
    SOURCE_NSC: 'SOURCE_NSC',
    SOURCE_CANDEX: 'SOURCE_CANDEX',
    SOURCE_PUNCHOUT: 'SOURCE_PUNCHOUT',
    SOURCE_NESTBUY: 'SOURCE_NESTBUY',
    SOURCE_PSL: 'SOURCE_PSL',
    WAY_OF_BUYING_FO: 'WAY_OF_BUYING_FO',
    FREE_ITEM: 'FREE_ITEM',
};
